import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AREAS } from "@/content";

const field = "rounded-xl h-12 border-navy-200 bg-white focus-visible:ring-navy-900 text-navy-900";

export const emptyContact = { name: "", email: "", phone: "", area: "", message: "", privacy: false };

export const ContactFields = ({ value, onChange, ids, messageRequired = false }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e?.target ? e.target.value : e });
  return (
    <div className="grid sm:grid-cols-2 gap-5">
      <div className="sm:col-span-2 space-y-2">
        <Label htmlFor={ids.name} className="text-navy-900">Nome e cognome / Ragione sociale *</Label>
        <Input id={ids.name} data-testid={ids.name} required minLength={2} value={value.name} onChange={set("name")} className={field} />
      </div>
      <div className="space-y-2">
        <Label htmlFor={ids.email} className="text-navy-900">Email *</Label>
        <Input id={ids.email} data-testid={ids.email} type="email" required value={value.email} onChange={set("email")} className={field} />
      </div>
      <div className="space-y-2">
        <Label htmlFor={ids.phone} className="text-navy-900">Telefono *</Label>
        <Input id={ids.phone} data-testid={ids.phone} type="tel" required minLength={6} value={value.phone} onChange={set("phone")} className={field} />
      </div>
      <div className="sm:col-span-2 space-y-2">
        <Label className="text-navy-900">Materia</Label>
        <Select value={value.area} onValueChange={set("area")}>
          <SelectTrigger data-testid={ids.area} className={field}>
            <SelectValue placeholder="Seleziona l'area di interesse" />
          </SelectTrigger>
          <SelectContent>
            {AREAS.map((a) => (
              <SelectItem key={a.key} value={a.title} data-testid={`${ids.area}-option-${a.key}`}>{a.title}</SelectItem>
            ))}
            <SelectItem value="Altro" data-testid={`${ids.area}-option-altro`}>Altro</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="sm:col-span-2 space-y-2">
        <Label htmlFor={ids.message} className="text-navy-900">
          {messageRequired ? "Descrivi brevemente la questione *" : "Note (facoltative)"}
        </Label>
        <Textarea
          id={ids.message}
          data-testid={ids.message}
          required={messageRequired}
          minLength={messageRequired ? 5 : undefined}
          rows={4}
          value={value.message}
          onChange={set("message")}
          className="rounded-xl border-navy-200 bg-white focus-visible:ring-navy-900 text-navy-900"
        />
      </div>
      <div className="sm:col-span-2 flex items-start gap-3">
        <Checkbox
          id={ids.privacy}
          data-testid={ids.privacy}
          checked={value.privacy}
          onCheckedChange={(c) => onChange({ ...value, privacy: c === true })}
          className="mt-0.5 rounded-none border-navy-900 data-[state=checked]:bg-navy-900"
        />
        <Label htmlFor={ids.privacy} className="text-sm font-normal leading-relaxed text-navy-500">
          Ho letto l'informativa privacy e acconsento al trattamento dei dati per essere ricontattato. *
        </Label>
      </div>
    </div>
  );
};
